/*
 * @Author: Teemo Ding
 * @Date: 2021-08-19 11:41:13
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-10 14:50:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogoManagement/Components/ImageUpLoader/index.tsx
 */
import { Uploader } from '@/src/components';
import { useSingleImageEffect } from '@/src/components/Upload';
import _ from 'lodash';
import React from 'react';

const ImageUpLoader = (props) => {
  const { value, onChange, disabled } = props;
  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);

  return (
    <Uploader
      height={180}
      width={'auto'}
      multiple={false}
      fileList={fileList}
      imageWidth={180}
      disabled={disabled}
      onChange={(imgArr = []) => {
        setFileList(imgArr);
        // if (onChange) {
        const _l = _.last(imgArr);
        onChange(_l);
        // }
      }}></Uploader>
  );
};

export default ImageUpLoader;
